import { IFrame } from '.'

type Props = {
  id: string
}

export const YouTube = ({ id }: Props) => (
  <IFrame
    src={`https://www.youtube.com/embed/${id}`}
    title="YouTube video player"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowFullScreen
  />
)
